module.exports = __webpack_public_path__ + "img/project10_4.jpg.c7b40042.webp";